<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <b-form @submit.prevent="onSubmit" class="h-100 d-flex flex-column overflow-hidden">
        <div class="d-flex justify-content-end">
          <b-button variant="primary" size="lg" class="pl-4 pr-4" @click="onSubmit">
            {{ 'save' | i18n }}
          </b-button>
        </div>
        <b-tabs
          pills
          card
          active-tab-class="px-0"
          content-class="overflow-auto overflow-x-hidden pr-1 pl-2 ml-1"
          class="d-flex flex-column overflow-hidden"
        >
          <b-tab v-if="isONEProject || isReportModule" :title="'General' | i18n" active>
            <General v-if="settingsLoaded" :settings="settings" />
          </b-tab>
          <b-tab v-if="isONEProject || isReportModule || isRPTradeModule" :title="'E-Mail' | i18n">
            <Email
              v-if="settingsLoaded"
              :settings="settings"
              :isReportModule="isReportModule"
              :isRPTradeModule="isRPTradeModule"
              :isONEProject="isONEProject"
            />
          </b-tab>
          <b-tab v-if="isRPTradeModule" title="RP Trade">
            <RPTrade v-if="settingsLoaded" :settings="settings" />
          </b-tab>
          <b-tab v-if="isRPTradeModule" :title="this.$translate('PDF Settings')">
            <PDF v-if="settingsLoaded" :settings="settings" />
          </b-tab>
          <b-tab v-if="isAVGProject" :title="this.$translate('AVG')">
            <AVG v-if="settingsLoaded" :settings="settings" />
          </b-tab>
          <b-tab v-if="isAVGProject" :title="this.$translate('recalculation')">
            <RecalculationAVG v-if="settingsLoaded" />
          </b-tab>
        </b-tabs>
        <Loader v-if="!settingsLoaded" />
      </b-form>
    </div>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue';
import { SettingsMixin, NotificationMixin, LocalStorageMixin, ApiMixin, LicenseMixin } from '../../../../mixins';
import { PDF_BACKGROUND_TYPE, PDF_PRESETS } from '../../../../../../../constants';

import General from './components/general';
import Email from './components/email/index';
import RPTrade from './components/RPTrade';
import PDF from './components/PDF';
import AVG from './components/AVG';
import RecalculationAVG from './components/recalculation';
import Loader from '../../common/loader';

export default {
  name: 'Settings',
  components: { RecalculationAVG, 'b-tabs': BTabs, 'b-tab': BTab, General, Email, RPTrade, PDF, Loader, AVG },
  mixins: [SettingsMixin, NotificationMixin, LocalStorageMixin, ApiMixin, LicenseMixin],
  data: function () {
    return {
      settingsLoaded: false,
      settings: {
        presetType: 'orders',
      },
      showPdfPreview: true,
      showDropFile: { bgFirst: false, bgFollowing: false },
      dropIntervalId: {},
      inputs: [],
      tabIndex: 0,
      sections: [],
    };
  },
  created() {
    this.settingsService.getSettings().then((response) => {
      this.settings = {
        shiftColors: {},
        absenceColors: {},
        ...this.settings,
        ...response,
        transfer_only_employee_related_customers: Boolean(response.transfer_only_employee_related_customers),
        reportLayoutRepeatedInformation: response.reportLayoutRepeatedInformation || {},
      };
      this.inputs = Object.keys(this.settings).map((key) => ({
        key: key,
        label: key,
        value: this.settings[key],
        inputType: 'text',
      }));
      this.localStorageService.set('importDefaultEncoding', this.settings.importDefaultEncoding);
      this.settingsLoaded = true;
    });
  },
  methods: {
    async onSubmit() {
      try {
        this.settingsLoaded = false;

        const settings = Object.assign({}, this.settings);
        if (settings.companyLogo) {
          const formData = new FormData();
          formData.append('file', settings.companyLogo);
          await this.settingsService.updateCompanyLogo(formData);
        }
        delete settings.companyLogo;
        if (settings.bgFirst) {
          const formData = new FormData();
          formData.append('file', settings.bgFirst);
          formData.append('preset', PDF_PRESETS[settings.presetType]);
          formData.append('templateType', PDF_BACKGROUND_TYPE.FIRST_PAGE);
          await this.settingsService.updatePdfPresets(formData);
        }
        delete settings.bgFirst;
        if (settings.bgFollowing) {
          const formData = new FormData();
          formData.append('file', settings.bgFollowing);
          formData.append('preset', PDF_PRESETS[settings.presetType]);
          formData.append('templateType', PDF_BACKGROUND_TYPE.FOLLOWING_PAGES);
          await this.settingsService.updatePdfPresets(formData);
        }
        delete settings.bgFollowing;
        delete settings.presetType;
        settings.transfer_only_employee_related_customers = Number(settings.transfer_only_employee_related_customers);
        await this.settingsService.updateSettings(settings);
        this.settings.bgFirst = null;
        this.settings.bgFollowing = null;

        this.localStorageService.set('importDefaultEncoding', settings.importDefaultEncoding);
        this.showNotification({ type: 'success', title: this.$translate('success'), message: this.$translate('settings_update_success_message') });
      } catch (err) {
        this.showNotification({
          type: 'error',
          title: this.$translate('error'),
          message: err && err.error ? err.error.message : this.$translate('settings_update_error_message'),
        });
      } finally {
        this.settingsLoaded = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .card-header {
  background: white;
}
::v-deep .nav-item a {
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
::v-deep .overflow-x-hidden {
  overflow-x: hidden!important;
}
</style>
